import { useState, useRef } from 'react';
import { api } from '../api';
import { styles } from '../styles';
import { BackIcon } from '../components/Icons';

function DocumentIcon() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="1.5">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <path d="M14 2v6h6" />
      <line x1="8" y1="13" x2="16" y2="13" />
      <line x1="8" y1="17" x2="13" y2="17" />
    </svg>
  );
}

export default function StatementUploadScreen({ currentUser, onScanned, onBack }) {
  const [scanning, setScanning] = useState(false);
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState(null);
  const fileRef = useRef();

  const handleFile = async (file) => {
    if (!file) return;

    if (file.type.startsWith('image/')) {
      setPreview(URL.createObjectURL(file));
    }
    setScanning(true);
    setError(null);

    try {
      const data = await api.upload(`/receipts/statement/scan?user_id=${currentUser}`, file);
      onScanned(data.transactions);
    } catch (e) {
      setError('Failed to scan statement. Please try a clearer image.');
      setPreview(null);
    } finally {
      setScanning(false);
    }
  };

  return (
    <div style={styles.screen}>
      <header style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>
          <BackIcon />
        </button>
        <h1 style={styles.headerTitle}>Import Statement</h1>
        <div style={{ width: 20 }} />
      </header>

      <input
        ref={fileRef}
        type="file"
        accept="image/*,application/pdf"
        onChange={(e) => handleFile(e.target.files[0])}
        style={{ display: 'none' }}
      />

      {preview || scanning ? (
        <div style={styles.previewContainer}>
          {preview && <img src={preview} alt="Statement preview" style={styles.preview} />}
          {scanning && (
            <div style={styles.uploadingOverlay}>
              <div style={styles.spinner} />
              <span>Scanning transactions...</span>
            </div>
          )}
        </div>
      ) : (
        <>
          <p style={uploadStyles.hint}>
            Take a screenshot of your credit card statement and upload it here.
            We'll extract the transactions and let you review before importing.
          </p>

          <div style={styles.addOptions}>
            <button
              style={styles.optionCard}
              onClick={() => fileRef.current?.click()}
              disabled={scanning}
            >
              <div style={styles.optionIcon}>
                <DocumentIcon />
              </div>
              <span style={styles.optionTitle}>Upload Statement Screenshot</span>
              <span style={styles.optionDesc}>Image or PDF of your CC statement</span>
            </button>
          </div>

          <div style={uploadStyles.tipBox}>
            <p style={uploadStyles.tipTitle}>Tips for best results</p>
            <ul style={uploadStyles.tipList}>
              <li>Include the full transactions table</li>
              <li>Make sure dates and amounts are clearly visible</li>
              <li>Pending transactions will be skipped automatically</li>
            </ul>
          </div>
        </>
      )}

      {error && <p style={styles.error}>{error}</p>}
    </div>
  );
}

const uploadStyles = {
  hint: {
    fontSize: 14,
    color: '#64748b',
    lineHeight: 1.5,
    marginBottom: 20,
    marginTop: 4,
  },
  tipBox: {
    marginTop: 24,
    padding: 16,
    backgroundColor: '#f1f5f9',
    borderRadius: 12,
  },
  tipTitle: {
    fontSize: 13,
    fontWeight: 600,
    color: '#475569',
    margin: '0 0 8px 0',
  },
  tipList: {
    margin: 0,
    paddingLeft: 18,
    fontSize: 13,
    color: '#64748b',
    lineHeight: 1.8,
  },
};
